import type { Component } from 'vue'
import { RouteRecordRaw } from 'vue-router'
import { IMetaType, openType, pathType, showType, RouteLevel } from "@/util/interface/route/route";
import { IOriginalMenu, IClientType, ILevel } from '@/util/interface/api/route/route';

export const getPath = (list: IOriginalMenu[], id: string, path: string): string => {
    let menu: string[] = path ? [path] : [];
    list.forEach(t => {
        if (t.id == id) {
            menu.push(t.code)
        }
    })

    return ''
}
export const getTree = (list: IOriginalMenu[], id: string) => {
    let treeData: { [key: string]: IOriginalMenu[] } = {};

    list.reduce((prev, next) => {
        if (next.parentId == id) {
            prev[id] = [];
        } else {

            getTree(list, next.parentId)
        }
        return prev
    }, {} as { [key: string]: IOriginalMenu[] })
}   
export const arrayToTree = (arr: IOriginalMenu[], id: string): any => {
    return arr.reduce((res, current) => {
        if (current.parentId === id) {
            // 二层路由，只需要拦截到2级即可
            // if(current.level == RouteLevel.child) {
            //     return res.concat([current])
            // }else {
                return res.concat(Object.assign(current, {
                    children: arrayToTree(arr, current.id)
                }));
            
            // }
        }
        return res
    }, [] as IOriginalMenu[]);
}
export const setRouter = (list: IOriginalMenu[],  path: string = ''): RouteRecordRaw[] => {

    return list.reduce((res, current) => {
        const route = setRouterRawData(current);
        if(current.children?.length) {
            
            return res.concat([{...Object.assign({...route}, {
                children: setRouter(current.children, '/' + path + current.code),
                component: () => import(`@/views${path}/${String(current.code)}/${String(current.code)}.vue`),
            })}]);
            
        }
        return res.concat([{...Object.assign({...route}, {
            children: [],
            component: () => import(`@/views${path}/${String(current.code)}/${String(current.code)}.vue`),
        })}]);
    }, [] as RouteRecordRaw[])
}
export const routeData: RouteRecordRaw = {
    name: '',
    path: '',
    redirect: '',
    children: [],
    meta: {}
}
export const setRouterRawData = (menu: IOriginalMenu): RouteRecordRaw => {
    return Object.assign(routeData, {
        path: menu.code,
        name: menu.code,
        children: menu.children,
        meta: {
            icon: '',
            title: menu.title,
            level: menu.level,

            showType: menu.showType,
            pathType: menu.pathType,
            sort: menu.sort,
            openType: menu.openType,
            id: menu.id,
            isMenu: menu.isEnable
        }

    })
}

export class OriginMenu {
    cTime?: string = ''  //创建时间
    clientType?: number = IClientType.pc  
    code?: string = ''   //就是路由名
    icon?:string = ''    //图标
    id?: string = ''
    isEnable?: boolean = true   //是否启用
    level?: ILevel = 1    //路由层级
    openType?: openType = 1    //打开方式，  
    parentId?: string = ''    //父id
    path?: string = ''    //路由的 path
    pathType?: pathType = pathType.mine  //链接类型  
    showType?: showType = showType.menu   //显示类型
    sort?: number = -1    //排序
    title?: string = ''    //页面标题
    uTime?: string = '';   //更新时间
    [key: string]: any
    constructor(option: OriginMenu) {
        for (const key in option) {
            if (Object.prototype.hasOwnProperty.call(option, key)) {
                const item = option[key];
                if(typeof this[key] == 'string') {
                    this[key] = item || ''
                }else if(typeof this[key] == 'number') {
                    this[key] = item || 0
                }else if(typeof this[key] == 'boolean') {
                    this[key] = item || false
                }else {
                    this[key] = item
                }
                
            }
        }
    }
}


export const addRouteItem = (router: any, name: string, route: RouteRecordRaw) => {
    router.addRoute(name, route);
}
export const addRoute = (router: any, name = 'Home', asyncRoutes: Array<RouteRecordRaw> = []) => {
    if (!Array.isArray(asyncRoutes)) return [];
    asyncRoutes.forEach(route => {
        addRouteItem(router, name, route)
    })
}
export const isInMenu = (name: string, list: any[], type: string = 'name') => {
    let activeName = '';
    list.forEach(t => {
        if(activeName) return
        if(t[type] == name) {
            activeName = name;
        }else {
            if(t.children?.length) {
                let aName = isInMenu(name, t.children);
                if(aName) {
                    activeName = aName;
                    return;
                }
            }
        }
    })
    return activeName
}